import Vue from 'vue';
import Vuex from 'vuex';
import ShardsVue from 'shards-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { sync } from 'vuex-router-sync';
import VueLocalStorage from 'vue-localstorage';
import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import LarErrors from './helpers/Errors';
import VueMask from './components/common/v-mask/index';
import common from './components/common';
import vSelect from 'vue-select';


import store from './store/index';
import GlobalPlugin from './helpers/global';
import customMessages from '@/utils/customMessages.js';

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import '@/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.scss';
import 'vue-select/dist/vue-select.css';
import '@/assets/scss/vue-select.override.scss';

// Core
import App from './App.vue';
import router from './router';

// Layouts
import Default from '@/layouts/Default.vue';
import LoginLayout from '@/layouts/Login.vue';

sync(store, router);

window.axios = axios;
const validate_config = {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    dictionary: null,
    errorBagName: 'errors', // change if property conflicts
    events: 'input|blur',
    fieldsBagName: 'fields',
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    inject: true,
    locale: 'pl',
    validity: false,
    useConstraintAttrs: true
};
VeeValidate.Validator.localize(customMessages);

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(GlobalPlugin);
Vue.use(VueLocalStorage);
Vue.use(VeeValidate, validate_config);
Vue.use(VueSweetalert2);
Vue.use(common);
Vue.use(VueMask);

const baseUrl = APP_URL ? APP_URL : 'https://tw-pozyczki.devsafi.pl/';
window.localStorage.setItem('baseUrl', baseUrl);
function getToken(){
    return window.localStorage.getItem('token');
}
axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ` + getToken()
};

axios.interceptors.response.use(undefined, function (error) {
    if(error.response.status === 401) {
        // Vue.swal({
        //     type:   'warning',
        //     title:  'Token sesji wygasł, zaloguj się ponownie.',
        //     showConfirmButton: true,
        // }).then(() => {
            window.localStorage.setItem('user', '');
            window.localStorage.setItem('token', '');
            router.push({name: 'login'});
            location.reload();
        // });
    } else if (error.response.status === 403) {
        Vue.swal({
            type:   'warning',
            title:  error.response.data.error ? error.response.data.error : 'Nie odnaleziono odniesienia do danej pozycji.',
            showConfirmButton: true,
        }).then(() => {
           router.push({name: 'dashboard'})
        });
    }
    return Promise.reject(error);
});

ShardsVue.install(Vue);

Vue.component('default-layout', Default);
Vue.component('login-layout', LoginLayout);
Vue.component('v-select', vSelect);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
Vue.prototype.$bus = new Vue();

window.Vue = Vue;
var vue_app = new Vue({
    components: LarErrors,
    localStorage: {
        baseUrl: baseUrl,
        token: {
            type: String,
            default: ''
        }
    },
    store,
    router,
    render: h => h(App),
    watch: {
        '$route'(){

            LarErrors.clear();
        }
    },
}).$mount('#app');
